import Entity from '../entity'

export default class Membership extends Entity<number>{
    userId: string  = null;
    userNo: string  = null;
    tenantId: number  = null;
    level: number  = null;
    remark: string  = null;
    vipCardId = null;
    vipCardName = null;
    vipCardImageUrl = null;
    discount = null;
    expiredTime = null;
    isExpired = true;
}